export const REACT_STATIC_IMPORT_YAML = `project:
  name: recipe-react
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: static
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-react-static`;
